import { Tree } from 'antd';
import { DataNode } from 'antd/lib/tree';

interface ReportAnalyzeCheckableTreeInputProps {
  data: DataNode[];
  value?: string[];
  defaultValue?: string[];
  onChange?: (keys: string[]) => void;
}

const ReportAnalyzeCheckableTreeInput = ({
  data,
  value,
  defaultValue,
  onChange,
}: ReportAnalyzeCheckableTreeInputProps) => {
  return (
    <Tree
      checkable
      defaultCheckedKeys={defaultValue}
      treeData={data}
      checkedKeys={value}
      onCheck={(keys) => {
        // @ts-expect-error: the created data only have strings as key
        onChange?.(keys);
      }}
    />
  );
};

export default ReportAnalyzeCheckableTreeInput;
